import {
	type GuestBusinessDetailsPayload,
	putGuestBusinessDetails,
} from "@/api/guest-business-details";
import { getUserInformationOptions } from "@/features/auth/useGetUserInformation";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export type UpdateGuestBusinessDetailsArgs = {
	locationId: number;
	guestId: number;
	businessDetailId: number;
	payload: GuestBusinessDetailsPayload;
};

export default function useUpdateGuestBusinessDetails(
	options?: MutationOptionsWithoutFn<void, UpdateGuestBusinessDetailsArgs>,
) {
	const queryClient = useQueryClient();
	const { onSuccess: userOnSuccess, ...rest } = options ?? {};
	return useMutation({
		mutationFn: ({
			locationId,
			guestId,
			businessDetailId,
			payload,
		}: UpdateGuestBusinessDetailsArgs) =>
			putGuestBusinessDetails(locationId, guestId, businessDetailId, payload),
		...rest,
		onSuccess: async (data, variables, context) => {
			await queryClient.fetchQuery(getUserInformationOptions());
			userOnSuccess?.(data, variables, context);
		},
	});
}
